import { useAtomValue } from 'jotai';
import { gameGoalEventDescriptionsAtom } from '@/atoms/queries/game';
import { GameStatsVideoLayout } from '@/components/layout/video/GameStatsVideoLayout';
import { useSetGameIdForVideos } from '@/hooks/useSetGameIdForVideos';
import { useVideoDataForEvents } from '@/hooks/useVideoDataForEvents';

export const GameGoalsVideoPage = () => {
  useSetGameIdForVideos();

  const gameGoalEventDescriptions = useAtomValue(gameGoalEventDescriptionsAtom);
  const { videoIds, unavailableVideosCount, ref } = useVideoDataForEvents<HTMLSpanElement>(gameGoalEventDescriptions);

  return (
    <span ref={ref}>
      <GameStatsVideoLayout
        videoEventIds={videoIds}
        descriptionsData={gameGoalEventDescriptions}
        unavailableVideosCount={unavailableVideosCount}
      />
    </span>
  );
};
